import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
export const FAQ = () => {
  return <section className="mb-10" data-id="element-146">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-147">
        Veelgestelde Vragen
      </h2>
      <div className="space-y-6" data-id="element-148">
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-149">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-150">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-151" />
            <h3 className="font-bold" data-id="element-152">"Maar Werkt Online Training Wel?"</h3>
          </div>
          <div className="p-4" data-id="element-153">
            <p className="leading-relaxed" data-id="element-154">
              Ik begrijp je twijfel. Misschien denk je: "Online training kan
              niet werken - ik heb persoonlijke begeleiding nodig."
            </p>
            <p className="leading-relaxed mt-2" data-id="element-155">
              Hier is het cruciale verschil: bij mijn methode wordt niet je hond
              getraind, maar train jij jezelf. En dat kan perfect online! Je
              leert een nieuwe taal spreken, en net zoals je Frans of Duits
              online kunt leren, kun je ook de hondentaal online onder de knie
              krijgen.
            </p>
            <p className="leading-relaxed mt-2" data-id="element-156">
              Bovendien hebben al meer dan 15.000 Nederlandse en Vlaamse baasjes
              bewezen dat het werkt. Plus je krijgt directe ondersteuning via
              onze community en email support.
            </p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-157">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-158">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-159" />
            <h3 className="font-bold" data-id="element-160">"Maar Ik Heb Al Alles Geprobeerd..."</h3>
          </div>
          <div className="p-4" data-id="element-161">
            <p className="leading-relaxed" data-id="element-162">
              Misschien zeg je nu: "Amee, ik heb al alles geprobeerd - niets
              werkt meer."
            </p>
            <p className="leading-relaxed mt-2" data-id="element-163">
              Ik begrijp dat gevoel van wanhoop. Maar hier is het verschil: onze
              methode gaat over communicatie - de basis van alle gedrag.
              Waarschijnlijk heb je tot nu toe symptomen behandeld, niet de
              oorzaak.
            </p>
            <p className="leading-relaxed mt-2" data-id="element-164">
              Als je de taalbarrière wegneemt, lossen veel problemen als vanzelf
              op omdat je hond zich eindelijk begrepen voelt.
            </p>
          </div>
        </div>
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-165">
          <div className="bg-gray-50 p-4 flex items-start" data-id="element-166">
            <HelpCircleIcon className="w-5 h-5 text-blue-600 mr-2 mt-0.5 flex-shrink-0" data-id="element-167" />
            <h3 className="font-bold" data-id="element-168">"Mijn Hond Is Te Oud Of Te Moeilijk"</h3>
          </div>
          <div className="p-4" data-id="element-169">
            <p className="leading-relaxed" data-id="element-170">
              Ook dit hoor ik vaak. Het goede nieuws: het gaat niet om je hond
              veranderen, maar om jullie communicatie verbeteren. Elke hond,
              ongeacht leeftijd of karakter, kan leren. En eigenlijk leer vooral
              jij - je hond spreekt deze taal al zijn hele leven.
            </p>
          </div>
        </div>
      </div>
    </section>;
};